import { config } from 'util/config';
import { httpClient } from 'util/Api';
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  const componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  setTimeout(() => sectionComponent.getSectionDataByDefault(), config.setTimeoutMilliSecond);

  httpClient.get('Admin/WorkDescriptionMapping/GetChecklistGroupNameOptions', {
    params: { moduleId: parameter }
  }).then(({ data }) => {
    if (!data.result) {
      globalFunction.handleResultError(data, pageComponent);
      return;
    }
    const componentDataSource = { ...sectionComponent.state.componentDataSource };
    componentDataSource.ChecklistGroupName = data.data || [];
    sectionComponent.setState({ componentDataSource });
    const form = sectionComponent.customForm?.current;
    if (form) {
      const formDataSource = { ...form.state.componentDataSource, ChecklistGroupName: data.data || [] };
      form.setState({ componentDataSource: formDataSource });
    }
  }).catch(error => globalFunction.handleError(error, pageComponent));
}

function syncChecklistGroupNameOptions({ sectionComponent } = {}) {
  const options = sectionComponent.state.componentDataSource?.ChecklistGroupName || [];
  const form = sectionComponent.customForm?.current;
  if (!form) return;
  form.setState({
    componentDataSource: { ...form.state.componentDataSource, ChecklistGroupName: options }
  });
}

export function addWorkDescriptionMappingPopUpRun(args = {}) {
  syncChecklistGroupNameOptions(args);
}

export function editWorkDescriptionMappingPopUpRun(args = {}) {
  syncChecklistGroupNameOptions(args);
}
